
import { ActionType } from '../actionTypes';
import { Action } from '../actions/flyerConversionSettingsActions';

import {ErrorDto, ConversionDto} from '../../dtos'

interface ConversionUrlSettingsState {
    loading: boolean;
    error: ErrorDto | null;
    data: ConversionDto | null;
    type: string | null;
}

const initialState = {
    loading: false,
    error: null,
    data: null,
    type: null,
}

const reducer = (
    state: ConversionUrlSettingsState = initialState,
    action: Action
): ConversionUrlSettingsState => {
    switch (action.type) {
        case ActionType.GET_CONVERSION_URL_START:
            return { loading: true, error: null, data: null, type: action.type}

        case ActionType.GET_CONVERSION_URL_SUCCESS:
            return { loading: false, error: null, data: action.payload, type: action.type}

        case ActionType.GET_CONVERSION_URL_ERROR:
            return { loading: false, error: action.payload, data: null, type: action.type}

        case ActionType.GET_CONVERSION_URL_COMPLETED:
            return { ...state, loading: false, error: null, type: action.type}
        case ActionType.POST_CONVERSION_URL_START:
            return { loading: true, error: null, data: null, type: action.type}

        case ActionType.POST_CONVERSION_URL_SUCCESS:
            return { loading: false, error: null, data: action.payload, type: action.type}

        case ActionType.POST_CONVERSION_URL_ERROR:
            return { loading: false, error: action.payload, data: null, type: action.type}

        case ActionType.POST_CONVERSION_URL_COMPLETED:
            return { ...state, loading: false, error: null, type: action.type}
        default:
            return state;
    }
}

export default reducer;